import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
const DefectFormpopup = ({ defectOpen, defectClose, defectSubmit }) => {
  const [formData, setFormData] = useState({ projectkey: "", message: "", issueType: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    defectSubmit(formData);
    setFormData({ projectkey: "", message: "", issueType: "" });
  };

  return (
    <Dialog
      open={defectOpen}
      onClose={() => {
        defectClose();
      }}
      PaperProps={{
        sx: {
          width: 600,
          maxWidth: 600,
        },
      }}
    >
      <DialogTitle>Enter Your Project key and Message</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          name="projectkey"
          label="Project key"
          type="text"
          fullWidth
          value={formData.projectkey}
          onChange={handleChange}
        />
        <FormControl fullWidth>
          <InputLabel id="log-type-label">Select Log Type</InputLabel>
          <Select
            labelId="log-type-label"
            name="issueType"
            value={formData.issueType}
            onChange={handleChange}
            label="Select Log Type"
            fullWidth
          >
            <MenuItem value="Task">Log Task</MenuItem>
            <MenuItem value="Bug">Log Bug</MenuItem>
          </Select>
        </FormControl>
        <TextField
          margin="dense"
          name="message"
          label="Message"
          type="text"
          value={formData.message}
          onChange={handleChange}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={defectClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DefectFormpopup;
